module.exports = __webpack_public_path__ + "img/city1-s.dd1f7328.png";